import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    fetchAccessToken,
    fetchTeams,
    getAccessToken,
    getTeams,
    getConfigList,
    setConfigList
} from "./configSlice";
import { useNavigate } from "react-router-dom";
import Constants from "../../utils/constants";
import { Container } from "../../utils/ui";
import { ConfigWrapper } from "./style";
import Logo from '../../components/logo';
import ConfigList from "./configList";
import AddEditConfig from "./AddEditConfig";
import {setLocalData} from "../../services/storageManager";

export default function Config() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(getAccessToken);
    const teams = useSelector(getTeams);
    const configList = useSelector(getConfigList);
    const [isForUpdate, setIsForUpdate] = useState(false);
    const [isCloned, setIsCloned] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState(-1);
    const [openAddEditConfig, setOpenAddEditConfig] = useState(!configList || !configList.length);

    useEffect(() => {
        const clientID = '6MVJ18S3BGIZZXFA8DSNWNO00W654YL2';
        const clientSecret = '2W0MBLPNVJ3IQG8X9SOE9MQ5PTNTBDWTKC3O0J7Q7SSFB82XCZ6BFCGNWXRNDYPG';

        const urlParams = new URLSearchParams(window.location.search);
        let authCode = urlParams.get('code');

        if (!authCode && !accessToken)
            navigate(Constants.ROUTES.AUTHENTICATION);

        if (!accessToken)
            dispatch(fetchAccessToken({ code: authCode, clientSecret: clientSecret, clientID: clientID }));

    }, [dispatch, navigate, accessToken]);

    useEffect(() => {
        if (accessToken && (!teams || !teams.length)) {
            dispatch(fetchTeams(accessToken));
        }
    }, [accessToken]);

    useEffect(() => {
        let teamsList = teams.map(team => team.id);
        const urlParams = new URLSearchParams(window.location.search);
        if (teamsList) {
            if (urlParams.get('config') != 1) {
                for (let index = 0; index < configList.length; index++) {
                    if (teamsList.includes(configList[index]?.team?.id)) navigate(Constants.ROUTES.DEPARTMENT_LIST);
                }
            }
        }
    }, [teams])

    function addConfig() {
        setIsForUpdate(false);
        setOpenAddEditConfig(true);
    }

    function editConfig(index) {
        setSelectedConfig(index);
        setIsForUpdate(true);
        setOpenAddEditConfig(true);
    }

    function cloneConfig(index) {
        setSelectedConfig(index);
        setIsCloned(true);
        setOpenAddEditConfig(true);
    }

    function closedAddConfig() {
        setIsForUpdate(false);
        setIsCloned(false);
        setSelectedConfig(-1);
        setOpenAddEditConfig(false);
    }

    function deleteConfig(index) {
        const tempList = [...configList];
        tempList.splice(index, 1);
        dispatch(setConfigList(tempList));
    }

    function gotoTaskList(index) {
        setLocalData('selectedDept', JSON.stringify(configList[index].list));
        navigate(`${Constants.ROUTES.DEPARTMENT_LIST}/${configList[index].list.id}${Constants.ROUTES.SHIFT_LIST}`);
    }

    return (
        <>
            <Container sx={{ height: '100%' }}>
                <ConfigWrapper>
                    <Logo />
                    {!openAddEditConfig ?
                        <ConfigList
                            addConfig={addConfig}
                            editConfig={editConfig}
                            cloneConfig={cloneConfig}
                            deleteConfig={deleteConfig}
                            gotoTaskList={gotoTaskList}
                            configList={configList}
                            teams={teams}
                        /> :
                        <AddEditConfig teams={teams}
                            isCloned={isCloned}
                            isForUpdate={isForUpdate}
                            selectedConfig={selectedConfig}
                            configList={configList}
                            closedAddConfig={closedAddConfig}
                        />
                    }
                </ConfigWrapper>
            </Container>
        </>
    );
}